
import { City, Country, State, IGeoDatabase, GeoDatabaseGeoDBCities } from '@idha/idha-utils'
import { utilsModule } from '../utils-module';

let geoDBService: IGeoDatabase = undefined


/**
  * @ngdoc service
  * @name app.geoDBService
  * 
  * @description
  * Serviço para acesso a informações de localizações globais
  * (países, estados/regiões e municícpios)
  * 
  * @example
  * let countries:Country = await geoDBService.listCountries();
**/
utilsModule.service('geoDBService', ['serverAddress', function (serverAddress) {
    let accessToken: string = window.localStorage.getItem('$LoopBack$accessTokenId');
    var managerURL = serverAddress.managerURL;
    var https = managerURL.indexOf("https") > -1;

    function getPort(host) {
        var r = /:([0-9]+)/

        var m = r.exec(host)

        let port =  m && m.length > 1 ?
                m[1] : 
                (https ? "443" : "80") 

        let portOnAddress = m && m.length > 1
        

        return {port,portOnAddress}
    }
    
    var {port,portOnAddress} = getPort(managerURL)

    var host = managerURL.slice(
        managerURL.indexOf("://") + 3, 
        portOnAddress ? managerURL.indexOf(port) - 1 : managerURL.lastIndexOf("/")
    )


    return new GeoDatabaseGeoDBCities('pt', host, port, https, accessToken);
}])

utilsModule.run(['$injector', function ($injector) {
    geoDBService = $injector.get('geoDBService')
}])



//================================================================================


class GeoDatabaseFake implements IGeoDatabase {
    changeLanguage() {

    }
    async listCountries(): Promise<Country[]> {
        return [
            brazil, EUA, France
        ]
    }
    async listStates(country?: string): Promise<State[]> {
        if (country == 'Brasil') {
            return [
                MG,
                SP,
                RJ
            ]
        } else if (country == 'Estados Unidos') {
            return [NY, NB]
        }
    }
    async listCities(country?: string, state?: string): Promise<City[]> {
        if ((country.toUpperCase() == 'BRASIL') && (state == 'MG')) {
            return [
                <City>{
                    state: MG,
                    name: 'Belo Horizonte'
                },
                <City>{
                    state: MG,
                    name: 'Nova Lima'
                }
            ]
        } else if ((country.toUpperCase() == 'BRASIL') && (state == 'SP')) {
            return [
                <City>{
                    state: SP,
                    name: 'São Paulo'
                },
                <City>{
                    state: SP,
                    name: 'Campinas'
                }
            ]
        } else if ((country.toUpperCase() == 'BRASIL') && (state == 'RJ')) {
            return [
                <City>{
                    state: RJ,
                    name: 'Rio de Janeiro'
                },
                <City>{
                    state: RJ,
                    name: 'Petrópolis'
                }
            ]
        }
    }

    setToken(token: string) {

    }
}
var brazil = <Country>{
    name: 'Brasil',
    code: 'BR'
};
var EUA = <Country>{
    name: 'Estados Unidos',
    code: 'EUA'
};
var France = <Country>{
    name: 'France',
    code: 'FRA'
};

var MG = <State>{
    country: brazil,
    name: 'Minas Gerais',
    sigle: 'MG'
};
var SP = <State>{
    country: brazil,
    name: 'São Paulo',
    sigle: 'SP'
};
var RJ = <State>{
    country: brazil,
    name: 'Rio de Janeiro',
    sigle: 'RJ'
};

var NY = <State>{
    country: EUA,
    name: 'Nova York',
    sigle: 'NY'
};
var NB = <State>{
    country: EUA,
    name: 'Nebraska',
    sigle: 'NB'
};

export { geoDBService };                                  